module.exports = __webpack_public_path__ + "img/title-in.40dd50ba.png";